/**
 * SubscriptionApiClient -- HTTP client for /api/businesses/{id}/subscriptions
 * and the feature-gating endpoints from PANEL-SUBS-FEATURES-001 / T2:
 *   - GET /api/v1/plans/{planCode}/features
 *   - GET /api/v1/businesses/{businessId}/features
 *
 * @module infrastructure/api/SubscriptionApiClient
 */

import { ApiBase } from './ApiBase.js';

const BASE = (bizId) => `/api/businesses/${bizId}/subscriptions`;

export const SubscriptionApiClient = {
  async list(businessId) {
    return ApiBase.get(BASE(businessId));
  },

  async create(businessId, payload) {
    return ApiBase.post(BASE(businessId), payload);
  },

  async update(businessId, subscriptionId, payload) {
    return ApiBase.put(`${BASE(businessId)}/${subscriptionId}`, payload);
  },

  async remove(businessId, subscriptionId) {
    return ApiBase.del(`${BASE(businessId)}/${subscriptionId}`);
  },

  /**
   * Catalogo de features de un plan (PANEL-SUBS-FEATURES-001 T2).
   * Devuelve TODAS las features (incluye enabled=false para tooltips).
   * @param {string} planCode - "Pro", "Pro Marketing", "Básico" — el server normaliza.
   * @returns {Promise<{ok: boolean, data?: Array, error?: object}>}
   */
  async fetchPlanFeatures(planCode) {
    return ApiBase.get(`/api/v1/plans/${encodeURIComponent(planCode)}/features`);
  },

  /**
   * Features efectivos de un negocio segun su subscription activa
   * (PANEL-SUBS-FEATURES-001 T2). Devuelve BusinessFeaturesResponse:
   *   { businessId, planCode, planRaw, subscriptionStatus, subscriptionStartDate,
   *     subscriptionEndDate, hasActiveSubscription, features:[], message }
   * Si no hay subscription activa, hasActiveSubscription=false y features=[].
   */
  async fetchBusinessFeatures(businessId) {
    return ApiBase.get(`/api/v1/businesses/${encodeURIComponent(businessId)}/features`);
  }
};
